import React from 'react';
import { connect } from 'react-redux';
import MegasTelcel from '../../molecules/carousels/MegasTelcel';
import { SERVICE_ID_TELCEL_PLANES, SERVICE_ID_TELCEL_POSPAGO, SERVICE_ID_TELCEL_RECARGA } from '../../../constants';

const CarouselMegasTelcel = ({ 
    origin,
    margin,
	paymentMethods, 
	isAnonimous, 
	appSyncValues,
    cardInfo,
    handleInputClick,
    serviceId,
    amount,
    handleBannerClick
}) => {

	const [banners, setBanners] = React.useState({});
    const [newMargin, setNewMargin] = React.useState(margin);

	React.useEffect(() => {
		if (appSyncValues && appSyncValues.banks) {
			const { banks } = appSyncValues;
            let screen = {};

            switch (origin) {
                case "MiTelcel":
                    setBanners(
                        paymentMethods && paymentMethods.hasN2 
                        ? banks[0].screens.find(screen => screen.code === "SCREEN-28")
                        : banks[0].screens.find(screen => screen.code === "SCREEN-29")
                    );
                break;

                case "BodyPayments":
                    // Invitation banner
                    if (!paymentMethods || (paymentMethods && !paymentMethods.hasN2)) {
                        screen = banks[0].screens.find(screen => screen.code === "SCREEN-31");
                        setNewMargin(serviceId == SERVICE_ID_TELCEL_PLANES ? "0px 6% 0px 6%" : "10px 6% 20px 6%")
                    }
                    
                    // Change to N2 banner
                    if (serviceId === SERVICE_ID_TELCEL_PLANES || serviceId === SERVICE_ID_TELCEL_RECARGA) {
                        if (paymentMethods && paymentMethods.hasN2 && cardInfo && cardInfo.value !== "claro-pay") {
                            screen = banks[0].screens.find(screen => screen.code === "SCREEN-32");
                        }
                    }
                   
                    if (
                        serviceId === SERVICE_ID_TELCEL_POSPAGO && 
                        banks[0].properties &&
                        banks[0].properties.MIN_BILL_PAYMENT_BENEFIT &&
                        (parseFloat(amount.replaceAll(",", "")) >= parseFloat(banks[0].properties.MIN_BILL_PAYMENT_BENEFIT))
                    ) {
                        if (paymentMethods && paymentMethods.hasN2 && cardInfo && cardInfo.value !== "claro-pay") {
                            screen = banks[0].screens.find(screen => screen.code === "SCREEN-33");
                        }
                    }
                    
                    setBanners(screen);
                break;

                case "SelectPaymentMethod":
                    // Invitation banner
                    if (!paymentMethods || (paymentMethods && !paymentMethods.hasN2)) {
                        screen = banks[0].screens.find(screen => screen.code === "SCREEN-35");
                    }
                    setBanners(screen);
                break;
            
                default:
                break;
            }
		}
	}, [appSyncValues, paymentMethods, cardInfo, isAnonimous, amount])

	return (
        <>
            {
                banners &&
                banners.sections 
                    ? <MegasTelcel 
                        banners={ banners } 
                        isAnonimous={ isAnonimous } 
                        margin={ newMargin }
                        handleInputClick={ handleInputClick }
                        autoPlayDelay={                         
                            appSyncValues.banks[0].properties && 
                            appSyncValues.banks[0].properties.CAROUSEL_SLIDE_DURATION
                                ? parseFloat(appSyncValues.banks[0].properties.CAROUSEL_SLIDE_DURATION)
                                : 2500
                        } 
                        handleBannerClick={handleBannerClick}
                        />
                    : <></>
            }
        </>
        
	)
}

const mapStateToProps = (state) => {
	const { payments } = state;
	const { paymentMethods, isAnonimous, appSyncValues, cardInfo } = payments;
	return {
		paymentMethods,
		isAnonimous,
		appSyncValues,
        cardInfo
	}
}

export default connect(mapStateToProps)(CarouselMegasTelcel);